module.exports = "<div class=postcard-field ng-show=media> <img ng-src=\"{{ media.original_file_url }}\" alt=\"{{ media.caption }}\" class=postcard-image> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/post-preview-media.html
// module id = 736
// module chunks = 0